import { useEffect } from 'react';
import SiteNavbar from './SiteNavbar';
import SiteFooter from './SiteFooter';

const NAVY      = '#0D1B2A';
const WHITE     = '#FFFFFF';
const GRAY_BG   = '#F6F6F6';
const FONT_HEAD = "'Bebas Neue', sans-serif";
const FONT_BODY = "'DM Sans', sans-serif";

// Wraps a static legal document (exported as HTML from Termly) in the site's
// standard chrome. The Termly export's own wording/markup is rendered as-is
// via dangerouslySetInnerHTML -- only its typography is restyled, scoped to
// `.legal-doc-body`, so nothing in the actual legal text is altered.
export default function LegalPageLayout({ title, pageTitle, html }) {
  useEffect(() => {
    document.title = pageTitle || `${title} | Vocation Works`;
  }, [title, pageTitle]);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@400;500;600;700&display=swap';
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  return (
    <div style={{ backgroundColor: WHITE, minHeight: '100vh' }}>
      <SiteNavbar />

      <header style={{ backgroundColor: NAVY, padding: '3.5rem 2rem 3rem' }}>
        <div style={{ maxWidth: '740px', margin: '0 auto' }}>
          <h1 style={{
            fontFamily: FONT_HEAD, fontSize: 'clamp(2.25rem, 6vw, 3.25rem)',
            letterSpacing: '0.02em', color: WHITE, lineHeight: 1.1,
          }}>
            {title}
          </h1>
        </div>
      </header>

      <main style={{ backgroundColor: GRAY_BG, padding: '3rem 2rem 4rem' }}>
        <div
          className="legal-doc-body"
          style={{
            maxWidth: '740px', margin: '0 auto', backgroundColor: WHITE,
            borderRadius: '8px', padding: 'clamp(1.5rem, 5vw, 3rem)',
            boxShadow: '0 2px 16px rgba(13,27,42,0.06)',
            fontFamily: FONT_BODY, color: '#2A2A2A', lineHeight: 1.75,
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </main>

      <SiteFooter />

      <style>{`
        .legal-doc-body h1, .legal-doc-body h2, .legal-doc-body h3, .legal-doc-body h4 {
          font-family: ${FONT_BODY};
          color: ${NAVY};
          line-height: 1.3;
          margin: 1.75em 0 0.75em;
        }
        .legal-doc-body h1:first-child, .legal-doc-body h2:first-child { margin-top: 0; }
        .legal-doc-body h1 { font-size: 1.5rem; font-weight: 700; }
        .legal-doc-body h2 { font-size: 1.25rem; font-weight: 700; }
        .legal-doc-body h3 { font-size: 1.1rem; font-weight: 700; }
        .legal-doc-body h4 { font-size: 1rem; font-weight: 700; }
        .legal-doc-body p, .legal-doc-body li { font-size: 0.98rem; }
        .legal-doc-body p { margin: 0 0 1em; }
        .legal-doc-body ul, .legal-doc-body ol { margin: 0 0 1em; padding-left: 1.5em; }
        .legal-doc-body li { margin-bottom: 0.4em; }
        .legal-doc-body a { color: #96600A; word-break: break-word; }
        .legal-doc-body a:hover { text-decoration: underline; }
        .legal-doc-body strong, .legal-doc-body b { color: ${NAVY}; }
        .legal-doc-body table { width: 100%; border-collapse: collapse; margin: 0 0 1.5em; font-size: 0.9rem; display: block; overflow-x: auto; }
        .legal-doc-body th, .legal-doc-body td { border: 1px solid #E0E0E0; padding: 0.6em 0.8em; text-align: left; }
        .legal-doc-body th { background-color: ${GRAY_BG}; }
        .legal-doc-body hr { border: none; border-top: 1px solid #E0E0E0; margin: 2em 0; }
      `}</style>
    </div>
  );
}
